<script>
import Loader from "@/components/widgets/loader";
import apibtoast from "@/helpers/apibtoast";
import apigeneric from "@/helpers/apigeneric";
import gorevlendirmeyazisi from "./gorevlendirmeyazisi.vue";

export default {
  mixins: [apibtoast, apigeneric],
  props: ["satdosyaId", "Tamamlandi"],
  data() {
    return {
      FormData: {},
      GorevlendirmeTableUpdate: false,
    };
  },
  components: {
    Loader,
    gorevlendirmeyazisi,
  },
  watch: {
    satdosyaId() {
      this.Get();
    },
  },
  methods: {
    onSubmit() {
      this.Update("satdosya", this.FormData).then((res) => {
        if (res) {
          this.$bvModal.hide("Tekniksartnamekomisyonu");
          this.GorevlendirmeTableUpdate = true;
        }
      });
    },
    Get() {
      this.ActionsSingleGet({
        Service: "satdosya",
        Id: this.satdosyaId,
      }).then((res) => {
        this.FormData = res.Data;
        if (!this.FormData.Tekniksartnamekomisyonu) {
          this.FormData.Tekniksartnamekomisyonu = [];
        }
      });
    },
    AddGorevli() {
      this.FormData.Tekniksartnamekomisyonu.push({ AdSoyad: "", Unvan: "" });
    },
    DelGorevli(index) {
      this.FormData.Tekniksartnamekomisyonu.splice(index, 1);
    },
  },
};
</script>
<template>
  <Loader>
    <b-modal
      id="tekniksartnamekomisyonu"
      size="xl"
      :title="'Teknik Şartname Komisyonu'"
      title-class="font-18"
      hide-footer
    >
      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-sm-12">
                  <div class="text-sm-center">
                    <button
                      v-if="FormData.Tekniksartnamekomisyonu.length != 0"
                      v-b-modal.gorevlendirmeyazisi
                      class="btn btn-secondary"
                    >
                      <i class="mdi mdi-eye me-1"></i>
                      Görevlendirme Yazısı
                    </button>
                  </div>
                </div>
              </div>
              <br />

              <Form @submit.prevent="onSubmit">
                <div class="inner-repeater mb-4">
                  <div class="inner mb-3">
                    <div
                      v-for="(data, index) in FormData.Tekniksartnamekomisyonu"
                      :key="data.id"
                      class="inner mb-3 row"
                    >
                      <div class="col-md-5 col-4">
                        <label>Adı Soyadı</label>
                        <input
                          v-model="data.AdSoyad"
                          :disabled="Tamamlandi"
                          type="text"
                          class="inner form-control"
                        />
                      </div>
                      <div class="col-md-5 col-4">
                        <label>Ünvanı</label>
                        <input
                          v-model="data.Unvan"
                          :disabled="Tamamlandi"
                          type="text"
                          class="inner form-control"
                        />
                      </div>
                      <div class="col-md-1 col-4">
                        <label> &nbsp;</label>
                        <div class="d-grid">
                          <input
                            type="button"
                            class="btn btn-primary btn-block"
                            :value="'Sil'"
                            @click="DelGorevli(index)"
                            v-if="!Tamamlandi"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-5">
                    <button
                      v-if="
                        FormData.Tekniksartnamekomisyonu.length != 0 &&
                          !Tamamlandi
                      "
                      class="btn btn-primary"
                      type="submit"
                    >
                      Kaydet
                    </button>
                  </div>

                  <div class="col-sm-2">
                    <input
                      type="button"
                      class="btn btn-success inner"
                      :value="'Ekle'"
                      @click="AddGorevli"
                      v-if="!Tamamlandi"
                    />
                  </div>
                </div>
              </Form>
            </div>
          </div>
        </div>
      </div>

      <gorevlendirmeyazisi
        :satdosyaId="satdosyaId"
        :TableUpdate="GorevlendirmeTableUpdate"
        @TableUpdate="GorevlendirmeTableUpdate = $event"
      />
    </b-modal>
  </Loader>
</template>
